const defaultStatus = {
    title: '부가서비스 / 결제 내역',
    tabId: 'more'
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/payment.js